import * as React from "react";
import { useSelector } from "react-redux";
import { Icon } from "@fluentui/react/lib/Icon";
import { TooltipHost } from "@fluentui/react";

import { TEXT } from "../../../../../shared/constants/texts";
import { ICON } from "../../../../../shared/constants/icons";

type FolderListingProps = {
  selectedData: any;
  onFolderClick: any;
};

const FolderListing: React.FC<FolderListingProps> = (props) => {
  const { selectedData, onFolderClick } = props;
  const state = useSelector((state: any) => state.addToIciSlice);
  const { folderData } = state;

  let folderDataToRender = null;
  const ifFoldersPresent =
    folderData &&
    folderData.folderStructure &&
    folderData.folderStructure.items &&
    folderData.folderStructure.items.length > 0;
  if (ifFoldersPresent) {
    folderDataToRender = { items: folderData.folderStructure.items };
  }

  return ifFoldersPresent ? (
    <React.Fragment>
      <div className="folder-listing-container-single-email-upload">
        <FolderView data={folderDataToRender} selectedData={selectedData} onFolderClick={onFolderClick} />
      </div>
    </React.Fragment>
  ) : (
    <EmptyFolders />
  );
};

export const FolderView = (props) => {
  const { data, selectedData, onFolderClick } = props;
  const [isFolderExpanded, setIsFolderExpanded] = React.useState(false);
  const [showInstancesId, setShowInstancesId] = React.useState(null);

  const onIconToggleClicked = (data) => {
    setIsFolderExpanded(!isFolderExpanded);
    if (showInstancesId === data.id) {
      setShowInstancesId(null);
    } else {
      setShowInstancesId(data.id);
    }
  };

  let classNameForFolder = "single-folder-container-single-email-upload";
  if (selectedData && selectedData.id === data.id) {
    classNameForFolder = "single-folder-container-selected-single-email-upload";
  }

  let classNameForChevronIcon = "icon-toggle-hidden";
  if (data && data.items && data.items.length > 0) {
    classNameForChevronIcon = "icon-toggle";
  }

  return (
    <div className="folder-view-container-single-email-upload">
      {data.displayName ? (
        <div className={classNameForFolder} onClick={() => onFolderClick(data)}>
          <React.Fragment>
            <div className={classNameForChevronIcon} onClick={() => onIconToggleClicked(data)}>
              <Icon iconName={showInstancesId && showInstancesId === data.id ? ICON.UP : ICON.DOWN} />
              <span className="sr-only">{showInstancesId && showInstancesId === data.id ? ICON.UP : ICON.DOWN}</span>
            </div>
            <div className="icon-folder">
              <Icon
                iconName={
                  showInstancesId && showInstancesId === data.id ? "FabricOpenFolderHorizontal" : "FabricFolder"
                }
              />
              <span className="sr-only">
                {showInstancesId && showInstancesId === data.id ? "FabricOpenFolderHorizontal" : "FabricFolder"}
              </span>
            </div>
            <div className="folder-label">
              <TooltipHost id="folder-tooltip-single-email-upload" content={data.displayName}>
                <p>{data.displayName}</p>
              </TooltipHost>
            </div>
          </React.Fragment>
        </div>
      ) : null}
      {(isFolderExpanded || !data.displayName) &&
        data.items.map((item) => {
          return <FolderView key={item.id} data={item} selectedData={selectedData} onFolderClick={onFolderClick} />;
        })}
    </div>
  );
};

const EmptyFolders = () => {
  return (
    <div className="folder-listing-empty-container-single-email-upload">
      <p>{TEXT.NO_FOLDERS_FOUND}</p>
    </div>
  );
};

export default FolderListing;
